import OtherMessageItem from './OtherMessageItem'

export default OtherMessageItem
